import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo } from 'react';
import MuiDialogContentText from '@material-ui/core/DialogContentText';
import { combineClasses, styled, useThemeProps, } from '../../../foundation';
import { TypographyStyle } from '../../Typography/styles';
import { MuiDefaultColor, RcCustomTypographyVariant, } from '../../Typography/utils';
import { useDialogDefaultProps } from '../utils';
import { DialogContentTextStyle } from './styles';
import { RcDialogContentTextClasses } from './utils';
var _RcDialogContentText = forwardRef(function (inProps, ref) {
    var props = useThemeProps({
        props: inProps,
        name: 'RcDialogContentText',
    });
    var colorProp = props.color, componentProp = props.component, classesProp = props.classes, variant = props.variant, weight = props.weight, size = props.size, children = props.children, rest = __rest(props, ["color", "component", "classes", "variant", "weight", "size", "children"]);
    var component = componentProp || RcCustomTypographyVariant[variant];
    var classes = useMemo(function () { return combineClasses(RcDialogContentTextClasses, classesProp); }, [classesProp]);
    var color = useMemo(function () {
        return MuiDefaultColor.includes(colorProp) ? colorProp : undefined;
    }, [colorProp]);
    return (React.createElement(MuiDialogContentText
    // * for use html view variant
    , __assign({ "data-variant": variant, "data-color": color, color: color, ref: ref, classes: classes, component: component }, rest), children));
});
var RcDialogContentText = styled(_RcDialogContentText).attrs(function (props) {
    var toProps = useDialogDefaultProps(props);
    return __assign({ variant: toProps.size === 'small' ? 'caption1' : 'body1', color: 'neutral.f04' }, toProps);
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), DialogContentTextStyle, TypographyStyle);
RcDialogContentText.defaultProps = {};
RcDialogContentText.displayName = 'RcDialogContentText';
export { RcDialogContentText };
var templateObject_1;
